import React from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { User, Lock, Bell, Globe } from 'lucide-react';
interface SettingsProps {
  onLogout: () => void;
}
export function Settings({
  onLogout
}: SettingsProps) {
  return <MainLayout title="Einstellungen" onLogout={onLogout} data-id="element-1206">
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-1207">
        <Card title="Profil Einstellungen" data-id="element-1208">
          <div className="flex items-start gap-6" data-id="element-1209">
            <div className="h-20 w-20 rounded-full bg-teal-500 flex items-center justify-center text-2xl font-bold text-white" data-id="element-1210">
              AD
            </div>
            <div className="flex-1 space-y-4" data-id="element-1211">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1212">
                <Input label="Vorname" defaultValue="Admin" data-id="element-1213" />
                <Input label="Nachname" defaultValue="User" data-id="element-1214" />
                <Input label="E-Mail" defaultValue="admin@neocube.one" data-id="element-1215" />
                <Input label="Rolle" defaultValue="Administrator" disabled data-id="element-1216" />
              </div>
              <Button data-id="element-1217">Speichern</Button>
            </div>
          </div>
        </Card>

        <Card title="Plattform Konfiguration" data-id="element-1218">
          <div className="space-y-4" data-id="element-1219">
            <div className="flex items-center justify-between py-3 border-b border-slate-100" data-id="element-1220">
              <div className="flex items-center gap-3" data-id="element-1221">
                <Bell className="h-5 w-5 text-slate-400" data-id="element-1222" />
                <div data-id="element-1223">
                  <h4 className="text-sm font-medium text-slate-900" data-id="element-1224">
                    E-Mail Benachrichtigungen
                  </h4>
                  <p className="text-xs text-slate-500" data-id="element-1225">
                    Bei kritischen Tickets und Updates
                  </p>
                </div>
              </div>
              <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in" data-id="element-1226">
                <input type="checkbox" name="toggle" id="toggle" className="toggle-checkbox absolute block w-5 h-5 rounded-full bg-white border-4 appearance-none cursor-pointer checked:right-0 checked:border-teal-500" defaultChecked data-id="element-1227" />
                <label htmlFor="toggle" className="toggle-label block overflow-hidden h-5 rounded-full bg-slate-300 cursor-pointer checked:bg-teal-500" data-id="element-1228"></label>
              </div>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-slate-100" data-id="element-1229">
              <div className="flex items-center gap-3" data-id="element-1230">
                <Lock className="h-5 w-5 text-slate-400" data-id="element-1231" />
                <div data-id="element-1232">
                  <h4 className="text-sm font-medium text-slate-900" data-id="element-1233">
                    2-Faktor Authentifizierung
                  </h4>
                  <p className="text-xs text-slate-500" data-id="element-1234">
                    Für alle Administratoren erzwingen
                  </p>
                </div>
              </div>
              <Button size="sm" variant="outline" data-id="element-1235">
                Konfigurieren
              </Button>
            </div>

            <div className="flex items-center justify-between py-3" data-id="element-1236">
              <div className="flex items-center gap-3" data-id="element-1237">
                <Globe className="h-5 w-5 text-slate-400" data-id="element-1238" />
                <div data-id="element-1239">
                  <h4 className="text-sm font-medium text-slate-900" data-id="element-1240">
                    Sprache
                  </h4>
                  <p className="text-xs text-slate-500" data-id="element-1241">
                    Plattform Spracheinstellung
                  </p>
                </div>
              </div>
              <span className="text-sm font-medium text-slate-900" data-id="element-1242">
                Deutsch (DE)
              </span>
            </div>
          </div>
        </Card>
      </div>
    </MainLayout>;
}